<template>
  <v-dialog
    v-model="show"
    max-width="650"
    class="assign-new-user-program-modal"
    scrollable
    persistent
  >
    <v-card>
      <v-card-title>
        <h4 class="mb-1">Add New User Program</h4>
      </v-card-title>

      <v-divider class="mb-5" />

      <v-card-text class="my-3">
        <search-programs
          v-model="form.program"
          :disabled="form.$busy"
          :error-messages="form.$getError('program')"
          :hide-details="!form.$getError('program')"
          label="Search Programs or Challenge"
          @change="programSelected"
          return-object
          is-for-filter
          clearable
          outlined
          flat
        />
      </v-card-text>

      <v-card-text v-if="form.program">
        <v-select
          v-model="form.variant"
          :items="variants"
          :disabled="form.$busy"
          :error-messages="form.$getError('variant_id')"
          label="Program Variants"
          item-text="validity"
          item-value="id"
          outlined
          flat
        />
      </v-card-text>

      <v-divider class="mb-3" />

      <v-card-actions class="px-5 pb-5">
        <v-spacer />

        <v-btn color="warning" :loading="form.$busy" @click="show = false" text>
          Cancel
        </v-btn>

        <v-btn
          color="primary"
          :loading="form.$busy"
          :disabled="!form.program"
          @click="addNewProgram"
          text
        >
          Add New Program
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import SearchPrograms from '@/components/elements/programs/SearchProgramsInput'
import Form from '@/utils/form'

import { mdiTrashCanOutline } from '@mdi/js'
import { mapActions, mapMutations } from 'vuex'

export default {
  name: 'AssignNewProgram',

  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },

  components: {
    SearchPrograms,
  },

  data() {
    return {
      variants: [],
      show: this.value,
      icons: {
        remove: mdiTrashCanOutline,
      },
      form: new Form({
        is_default: false,
        user_id: this.$route.params.id,
        variant: null,
        program: null,
      }),
    }
  },

  methods: {
    ...mapActions({
      assignNewUserProgram: 'users/assignNewUserProgram',
    }),

    ...mapMutations({
      setUserProgram: 'users/setUserProgram',
      attachNewProgram: 'userProfile/attachNewProgram',
      attachUserProgramToSwitcher: 'users/attachUserProgram',
    }),

    programSelected(program) {
      if (program) {
        this.variants = program.variants
      } else {
        this.errors = {}
      }
    },

    async addNewProgram() {
      this.form.$busy = true
      this.form.$clearErrors()

      await this.assignNewUserProgram({
        userId: this.$route.params.id,
        programId: this.form.program.id,
        variantId: this.form.variant,
      })
        .then(({ data }) => {
          setTimeout(() => {
            this.form.$busy = false
            this.show = false
            this.$emit('refresh-list')
          }, 600)
        })
        .catch(({ response }) => {
          setTimeout(() => {
            this.form.$busy = false

            if (response && response.status === 403) {
              this.form.$setErrors({ program: [response.data.message] })
            }

            if (response && response.status === 422) {
              this.form.$setErrors(response.data.errors)
            }
          }, 600)
        })
    },

    setData(data) {
      this.setUserProgram(data)
      this.attachNewProgram(data)
      this.attachUserProgramToSwitcher(data)
    },
  },

  watch: {
    value(val) {
      this.show = val
    },

    show(val) {
      this.$emit('input', val)

      if (!val) {
        this.errors = {}
        this.form.program = null
        this.form.variant = null
      }
    },
  },
}
</script>
